var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPTypeUpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.942,
    height: 29.663,
    viewBox: "0 0 20.942 29.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bhim",
    transform: "translate(-13.127 -5.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44449",
    "data-name": "Path 44449",
    d: "M20.339,27.456a7.2,7.2,0,0,0-1.364,1.162c-1.776,1.612-3.536,3.242-5.307,4.86a.572.572,0,0,1-.542.284L21.35,5.028l3.545,6.666c1.222,2.35,2.421,4.712,3.681,7.042a.875.875,0,0,1-.211,1.3c-2.664,2.4-5.291,4.847-7.931,7.277a.128.128,0,0,0-.1.151Z",
    transform: "translate(0)",
    fill: "#2f0d6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44450",
    "data-name": "Path 44450",
    d: "M24.734,28.149c2.64-2.43,5.267-4.874,7.931-7.278a.875.875,0,0,0,.211-1.3c-1.26-2.329-2.459-4.691-3.681-7.042L30.71,7.382l.148-.5a.373.373,0,0,1,.28.325q3.553,6.776,7.1,13.553a.523.523,0,0,1-.1.774Q30.558,28.455,23,35.4a.435.435,0,0,1-.33.119c.169-.6.335-1.2.506-1.8.471-1.648.947-3.293,1.411-4.941a.562.562,0,0,0,.057-.5l-.01.009c.137.02.1-.082.1-.15Z",
    transform: "translate(-4.3 -0.834)",
    fill: "#300787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44451",
    "data-name": "Path 44451",
    d: "M26.344,45.61c-.009.068.033.171-.1.15a.128.128,0,0,1,.1-.15Z",
    transform: "translate(-5.911 -18.295)",
    fill: "#fefefe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPTypeUpi);
export default __webpack_public_path__ + "static/media/p_type_upi.ae2efb5f8ef919afbe5fae3aa4a195b8.svg";
export { ForwardRef as ReactComponent };